<div *ngIf="step1 && !step2" class="wgu-container">
  <h2 class="mb-16">Setup Your Account</h2>
  <h3 class="mb-6">Step 3: Answer Security Questions</h3>
  <p class="mb-6">
    Please select three questions that you can easily remember. If you forget
    your password, you will be asked to answer these questions to verify your
    identity.
  </p>
  <p class="mb-6">
    <strong>NOTE: You MUST answer at least 3 questions.</strong>
  </p>

  <form
    [formGroup]="form"
    (ngSubmit)="submitAnswersStep1(form.value)"
    autocomplete="off"
    novalidate
  >
    <div class="w-full">
      <div *ngFor="let selectActual of selectLength; let i = index">
        <div
          *ngIf="selectLength?.length > 1 && i > 0"
          class="wgu-question-divider"
        >
          <button
            *ngIf="selectLength?.length > 2 && i > 2"
            (click)="removeItemFormControl(i)"
            class="close-btn cursor-pointer"
          >
            <img
              alt="Remove Security Question"
              class="img-responsive"
              src="/assets/images/securityquestions/Close.png"
              width="16"
            />
          </button>
        </div>

        <form-select
          class="general-questions"
          [formCtrl]="getQuestionFormControl(i)"
          [options]="getQuestions(i)"
          [label]="'Security Question ' + i"
          (onChange)="onChange($event)"
        >
        </form-select>

        <!-- <select class="select-text w-full"  formControlName="questionFormControl{{i}}" (change)="AddTarget(i,$event.target.value)" >

            <option *ngFor="let q of getQuestions(i)" [value]="q?.question" 
            [selected]="q?.question==form?.get('questionFormControl'+i)?.value" >{{q?.question}}</option>
          </select>
          <label class="select-label">Security Question {{i}}</label> -->

        <div class="form-group">
          <label class="wgu-outlined general">
            <!-- <em *ngIf="loginForm.controls.last_name?.invalid  && (loginForm.controls.last_name?.touched || mouseoverLogin)">Required</em>-->
            <input
              type="text"
              class="form-control"
              maxlength="40"
              id="questionAnswerInput"
              formControlName="answerFormControl{{ i }}"
              (blur)="saveAnswer()"
            />
            <span
              >Answer</span
            >
          </label>
        </div>
      </div>
    </div>

    <div class="wgu-security-bottom-label">
      <button
        *ngIf="selectLength?.length < maxSelectLength"
        (click)="addItemFormControl()"
        type="button"
      >
        + Add Another Security Question
      </button>
    </div>

    <div class="form-actions">
      <button class="wgu-btn" type="submit" [disabled]="!disabledFlag">
        Next
      </button>
      <a href="identityiq/external/cancelPage" class="wgu-btn-text">
        Cancel
      </a>
    </div>
  </form>
</div>

<div *ngIf="step2 && !step1" class="wgu-container">
  <h2>Setup Your Account</h2>
  <h3>Step 3: Answer Security Questions</h3>

  <p class="mb-6">
    Please review the answers to the questions you have chosen, you will be
    asked to answer these questions to verify your identity.
  </p>

  <div class="mb-6" *ngFor="let item of questionAnswerArr; let i = index">
    <p class="text-sm">Security question {{ i }}</p>

    <p>{{ item.question }}</p>

    <p>
      <strong>{{ item.answer }}</strong>
    </p>
  </div>

  <div class="form-actions">
    <button class="wgu-btn" (click)="submitAnswersStep2()">Next</button>
    <a href="identityiq/external/cancelPage" class="wgu-btn-text">
      Cancel
    </a>
  </div>
</div>

<div *ngIf="step3 && !step2 && !step1" class="wgu-container">
  <h2>Setup Your Account</h2>
  <h3>Step 4: Make Note of Your Username</h3>

  <p class="mb-6">
    Your username is <strong>{{ claim?.user_name }}</strong
    >.
  </p>
  <p>
    Your WGU email address will be
    <strong>{{ claim?.user_name }}&#64;wgu.edu</strong>. Please note that while your
    email address contains your username, you will sign in to WGU resources
    using only <strong>{{ claim?.user_name }}</strong>
  </p>
  <div class="form-actions">
    <button class="wgu-btn" (click)="submitAnswersStep3()">Next</button>
    <a href="identityiq/updateAccount/cancelPage" class="wgu-btn-text">
      Cancel
    </a>
  </div>
</div>
